import React, { useState } from "react";
import { ThemeProvider } from "styled-components";
import { darkTheme, lightTheme, GlobalStyles } from "./themes/theme.js";


// import Divider from "./components/Divider";
import Home from "./views/Home";
import About from "./views/About";
import Header from "./components/Header";
import Footer from "./components/Footer.js";
import Projects from "./views/Projects.js";

function App() {
  const [theme, setTheme] = useState("dark");
  const switchTheme = () => {
    theme === "dark" ? setTheme("light") : setTheme("dark");
  };
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />
      <div id="section1"></div>
      <Header theme={theme} switchTheme={switchTheme}/>
      <Home />
      <div className="area">
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
      {/* <Divider theme={theme} /> */}
      <About theme={theme} switchTheme={switchTheme}/>
      <Projects />
      <Footer />
    </ThemeProvider>
  );
}

var style2 = [
  "background: rgb(14,196,193);",
  "color: black",
  "padding: 10px 20px",
  "line-height: 35px",
  "text-align: center",
  "font-weight: 300",
  "font-size: large",
  "border : 5px solid black",
].join(";");

console.log("%c♥️ You got this far ♥️", style2);
console.log("%cI am looking to get hired...", style2);
console.log("%cMIGHT AS WELL EMAIL ME AT: pjpavo@gmail.com", style2);

setTimeout(function () {
  console.log("%cI knew you would! 😄 Thank you!", style2);
}, 9000);

export default App;
